//outbox home
import { ChangeDetectorRef, Component, inject, DestroyRef, effect, ElementRef, ViewChild  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, Observable, of } from 'rxjs';
import * as _ from 'lodash';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { VerbatimService } from 'src/app/shared/services/verbatim/verbatim.service';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LtmsDataTableV2Component } from '../../../../shared/components/ltms-data-table-v2/ltms-data-table-v2.component';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
import { OutboxDetailPanelComponent } from '../outbox-detail-panel/outbox-detail-panel.component';
import { OutboxRequestCreationComponent } from '../requests/outbox-request-creation/outbox-request-creation.component';
import { OutboxChannelSelectionPanelComponent } from '../outbox-channel-selection-panel/outbox-channel-selection-panel.component';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { SettingsService } from 'src/app/shared/services/settings';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
@Component({
  selector: 'app-project-outbox-home',
  templateUrl: './project-outbox-home.component.html',
  styleUrl: './project-outbox-home.component.scss',
  imports: [NgClass, NgIf, FormsModule, NgFor, LtmsDataTableV2Component, LtmsLoaderComponent, OutboxDetailPanelComponent, OutboxRequestCreationComponent, OutboxChannelSelectionPanelComponent]
})
export class ProjectOutboxHomeComponent {
  @ViewChild('dataTableContainer') tableContainer!: ElementRef;
  activeTab: string | null = 'responded';
  tabList: any = ['responded', 'not_responded']
  requestType: string = 'CFRA';
  isProjectManager: boolean = false;
  queryParams$: Observable<any> = of({});
  destroyRef = inject(DestroyRef);
  brandDetails = Helpers.brandDetails;
  fromDate!: number;
  toDate!: number;
  params: any = {}
  responded_list = {};
  non_responded_list = {};
  prepared_responded_list: any[] = [];
  prepared_non_responded_list: any[] = [];
  outboxRequestsData: any[] = [];
  selectedChannelDetail: any = null
  OutboxDetailsVisible: boolean = false;
  newReqestPanelVisible: boolean = false;
  isDetailPanelRefreshing: boolean = false;
  // Phase 2: channel selection panel
  channelSelectionPanelVisible: boolean = false;
  isChannelConfigLoading: boolean = false;
  isChannelPanelSending: boolean = false;
  showSelectChannelsButton: boolean = false;
  onDemandConfigurations: any = null;
  selectedRequestForChannelSend: any = null;
  selectedRowForChannelSend: any = null;
  /** Shown on channel panel only when search field is a tag_* and row has that value. */
  channelPanelTagContext: { label: string; value: string } | null = null;
  /** Link expiry timestamp for live countdown on channel panel. */
  channelPanelRequestDeadlineAt: Date | null = null;
  /** Absolute expiry text for channel panel toggle, e.g. "05 Sep '26 14:30". */
  channelPanelRequestDeadlineAbsolute: string | null = null;
  highlightedOnDemandAdhocEventId: any = null;
  highlightedOnDemandTableRow: any = null;
  showOnDemandChoiceModal: boolean = false;
  pendingOnDemandChoiceRow: any = null;
  pendingOnDemandChoiceRequest: any = null;
  errorCode = '404';
  requestsJourneyHeader: any[] = [];
  cohortFields: any[] = [];
  searchBoxVisible: boolean = false;
  isDataAvailable = false;
  configs = {
    isCollapsable: false
  }
  default_selected_type = 'CFRA';
  total_count_of_data = 0;
  tableConfig: any = {
    isRowClickable: true,
    nativeTooltip: false
  }

  brandOffsetName = {}
  pagingDetails: any = {
    start: 0,
    end: 0,
    pageSize: 10,
    pageNumber: 1,
    total: 0,
    totalpages: 1
  }

  pagingButtons: any = {
    isNext: false,
    isPrevious: false,
  }

  dates = {
    startDate: '',
    endDate: ''
  };

  // ===================================== Search ==============================
  searchText = "";
  searchAvailableOnList = [{
    field_id: "name",
    field_text: "Name"
  },
  {
    field_id: "email_address",
    field_text: "Email Address"
  },
  {
    field_id: "phone_number",
    field_text: "Phone Number"
  }
  ];
  outboxSearchFields = [];
  defaultSelectedField = this.searchAvailableOnList[1];
  showFilterFields = false;
  showSearchList = false;
  searchResult: any = {};
  placeholder = "Please search and select";
  isTextEntered = false;
  isCohertFilterApplied: boolean = false;
  is_cohort_based_search_enabled: boolean = false;
  is_cohort_based_search_enabled_brand_level: boolean = false;
  is_cohort_based_search_enabled_overall: boolean = false;
  isDataLoaded: boolean = false;
  isRequiredparameterrecive: boolean = false;
  istabchange: boolean = false;
  loading: any;
  hierarchyStack: any = [];

  readonly deliveryStatusDescriptions: Record<number, string> = {
    1: 'Request Delivered',
    2: 'Request Undelivered',
    3: 'Request Expired',
    4: 'Request Status Unknown',
    5: 'Request Deleted',
    6: 'Request Rejected',
    7: 'Request Delivery Pending',
    8: 'Customer has DND enabled'
  };

  fieldDefinitionsMap: any = {};
  showOnDemandTriggerColumn: boolean = false;
  readonly onDemandTriggerColumnKey = 'Send Notification';
  readonly defaultExpirationDelayMs = 30 * 24 * 60 * 60 * 1000; // 30 days

  constructor(private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    public _utilsService: UtilsService,
    private _helpers: HelpersService,
    public _verbatim: VerbatimService,
    private _appState: AppStateService,
    private _settingsService: SettingsService,
    private _toast: ToastService
  ) {
    effect(() => {
      if (this._appState.initialized()) {
        this.brandDetails = this._appState.brandDetails();
        this.resolveSelectChannelsButtonFromConfig();
        const state: any = this._appState.appState();
        this.brandOffsetName = this._helpers.getBrandTimezoneDetails(this.brandDetails);
        if (state?.managerAccess?.loggedInManager && !_.isEmpty(state?.managerAccess?.loggedInManager)) {
          this.isProjectManager = this.checkPermissonForRequestCreation(state.managerAccess.loggedInManager);
        }
        let datePickerObj: any = this._appState.datePicker();
        this.dates.startDate = datePickerObj.startDate;
        this.dates.endDate = datePickerObj.endDate;
        if(this.brandDetails.field_definitions && this.brandDetails.field_definitions.length > 0){
          this.cohortFields = [];
          _.each(this.brandDetails.field_definitions, (field: any) => {
             if(field.show_in_sent_detail == true && field.field_id != 'name' && field.field_id !='phone_number' && field.field_id!='email_address' && field.field_id != 'shop_name' && field.field_id != 'created_date' && field.field_id != 'feedback_request_date'){
              this.fieldDefinitionsMap[field.field_id] = field;
              this.cohortFields.push(field.field_id)
            }
          });
        }
        this.hierarchyStack = _.filter(state?.hierarchyStack, (hierarchy: any) => {
          return (hierarchy?.field_id && hierarchy?.field_id  != 'touchpoints');
        });
        this.prepared_responded_list = [];
        this.prepared_non_responded_list = []
        // this.total_count_of_data = 0;
        this.isRequiredparameterrecive = true
        this.resetData();
        if (this.activeTab == "not_responded") {
          this._settingsService.getSettingConfig("outbox_configurations").subscribe((res) => {
            this.is_cohort_based_search_enabled_overall = res.data?.cohort_based_search_configs?.is_cohort_based_search_enabled || false;
            this.is_cohort_based_search_enabled_brand_level = this.brandDetails?.module_configuration?.feedback?.submodules?.requests?.submodules?.is_on_demand_trigger_enabled?.visible || false;
            this.is_cohort_based_search_enabled = this.isCohortBasedSearchEnabled();
            this.searchAvailableOnList = this.getSearchAvailableOnList();
          })
        }
        if (this.istabchange) {
          if (this.default_selected_type == 'CFR') {
            this.getCFR();
          }

          if (this.default_selected_type == 'CFRA') {
            this.getCFRA();
          }
        }
      }
    });

  }


  ngOnInit() {
    // Initialize activeTab based on query parameters
    this.route.queryParams.subscribe((params: any) => {
      let tabName = (this.tabList.indexOf(params['active_tab']) >= 0) ? params['active_tab'] : 'responded';
      this.toggleTab(tabName);
      setTimeout(() => this.cdr.detectChanges()); // ✅ Safe trigger
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.tableContainer) {
        const container = this.tableContainer.nativeElement as HTMLElement;

        container.querySelectorAll('th, td').forEach((el: Element) => {
          const htmlEl = el as HTMLElement; // cast Element to HTMLElement
          if (!htmlEl.getAttribute('title')) {
            htmlEl.setAttribute('title', htmlEl.innerText.trim());
          }
        });
      }
    }, 0);
    document.addEventListener('click', (event) => {
      const ltmsOutboxsearchel: any = document.getElementById('ltmsOutboxsearch');
      if (ltmsOutboxsearchel && ltmsOutboxsearchel != event.target && !ltmsOutboxsearchel.contains(event.target)) {
        this.showFilterFields = false;
        this.showSearchList = false;
      }
    });
  }

  resetData() {
    this.pagingDetails = {
      start: 0,
      end: 0,
      pageSize: 10,
      pageNumber: 1,
      total: 0,
      totalpages: 1
    }
    this.total_count_of_data = 0;
    this.prepared_responded_list = [];
    this.prepared_non_responded_list = [];
    this.pagingButtons = {
      isNext: false,
      isPrevious: false,
    }
  }

  isCohortBasedSearchEnabled() {
    if (this.is_cohort_based_search_enabled_overall && this.is_cohort_based_search_enabled_brand_level && this.outboxSearchFields.length &&
      this.activeTab == "not_responded" && this.isValidCohortDateRange(this.dates.startDate)) {
      return true;
    }
    else {
      this.clearSearchBox();
      this.defaultSelectedField = this.searchAvailableOnList[1];
      return false;
    }
  }

  isValidCohortDateRange(fromDateString: string): boolean {
    if (!fromDateString || !/^\d{8}$/.test(fromDateString)) {
      return false;
    }

    const year = Number(fromDateString.substring(0, 4));
    const month = Number(fromDateString.substring(4, 6)) - 1; 
    const day = Number(fromDateString.substring(6, 8));

    const inputDate = new Date(year, month, day);

    // Validate that the parsed date matches the input
    if (
      inputDate.getFullYear() !== year ||
      inputDate.getMonth() !== month ||
      inputDate.getDate() !== day
    ) {
      return false;
    }

    inputDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const maxCohortSearchDays = this.brandDetails?.outbox_configurations?.max_cohort_search_days ?? 30;

    const minAllowedDate = new Date(today);
    minAllowedDate.setDate(today.getDate() - maxCohortSearchDays);

    return inputDate >= minAllowedDate && inputDate <= today;
  }

  
  getSearchAvailableOnList() {
    let searchListOptions = [{
      field_id: "name",
      field_text: "Name"
    },
    {
      field_id: "email_address",
      field_text: "Email Address"
    },
    {
      field_id: "phone_number",
      field_text: "Phone Number"
    }
    ];
    if (this.brandDetails?.field_definitions?.length) {
      this.outboxSearchFields = this.brandDetails?.field_definitions.filter(
        field => field.show_in_outbox_search
      );
    }
    if (this.is_cohort_based_search_enabled && this.outboxSearchFields.length) {
      this.outboxSearchFields.forEach((searchFields:any) => {
        searchListOptions.push({
          field_id: searchFields?.field_id,
          field_text: searchFields?.name
        })
      })
    }
    return searchListOptions;
  }

  checkPermissonForRequestCreation(loggedInManager: any) {
    let isProjectManager = false;
    if (parseInt(loggedInManager.manager_type) == 2 || parseInt(loggedInManager.manager_type) == 3) {
      isProjectManager = true;
      if (parseInt(loggedInManager.manager_type) == 2 && loggedInManager.access_key && Object.keys(loggedInManager.access_key)[0] != 'h_0_0') {
        isProjectManager = false;
      }
    }
    return isProjectManager;
  }

  /**
   * CFR (Not Responded) rows expose `adhoc_event_id` when on-demand trigger is applicable.
   */
  hasAdhocEventId(request: any): boolean {
    const adhocEventId = _.get(request, 'adhoc_event_id');
    return adhocEventId != null && adhocEventId !== '';
  }

  /**
   * Link validity window from brand config (ms). Defaults to 30 days when missing/invalid.
   */
  getExpirationDelayMs(): number {
    const configuredDelay = _.get(this.brandDetails, 'conversation_config.feedbacks.expiration_delay');
    const parsedDelay = Number(configuredDelay);
    if (!_.isNil(configuredDelay) && configuredDelay !== '' && !Number.isNaN(parsedDelay) && parsedDelay >= 0) {
      return parsedDelay;
    }
    return this.defaultExpirationDelayMs;
  }

  /**
   * Link expiry = request created_date + expiration_delay (ms).
   */
  getLinkExpiryDate(createdDate: string | number | Date): Date | null {
    if (_.isNil(createdDate) || createdDate === '') {
      return null;
    }
    const createdMs = new Date(createdDate).getTime();
    if (Number.isNaN(createdMs)) {
      return null;
    }
    return new Date(createdMs + this.getExpirationDelayMs());
  }

  /**
   * Option A: expired when current time is past link expiry.
   */
  isLinkExpired(createdDate: string | number | Date): boolean {
    const linkExpiryDate = this.getLinkExpiryDate(createdDate);
    if (!linkExpiryDate) {
      return true;
    }
    return Date.now() > linkExpiryDate.getTime();
  }

  /**
   * Absolute link expiry in brand timezone, e.g. "05 Sep '26 14:30".
   */
  formatLinkExpiryAbsolute(expiryDate: Date | null): string | null {
    if (!expiryDate) {
      return null;
    }
    const offset = this.brandOffsetName?.['__zone_symbol__value']?.['offset'];
    if (offset == null) {
      // Fallback if brand offset is not ready yet.
      const pad = (n: number) => String(n).padStart(2, '0');
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const yy = String(expiryDate.getFullYear()).slice(-2);
      return `${pad(expiryDate.getDate())} ${months[expiryDate.getMonth()]} '${yy} ${pad(expiryDate.getHours())}:${pad(expiryDate.getMinutes())}`;
    }
    return String(this._helpers.getTimeByOffset(offset, expiryDate, "DD MMM 'YY HH:mm"));
  }

  /**
   * Phase 2: if on-demand trigger is visible, load notifier config and
   * show "Select Channels" only when communication_channels.length > 1.
   */
  isOnDemandTriggerVisible(): boolean {
    const paths = [
      'module_configuration.feedback.submodules.requests.submodules.is_on_demand_trigger_enabled.visible',
      'module_configuration_v2.feedback.sub_modules.requests.sub_modules.is_on_demand_trigger_enabled.visible',
      'module_configuration.feedback.submodules.requests.submodules.is_on_demand_trigger_enabled',
      'module_configuration_v2.feedback.sub_modules.requests.sub_modules.is_on_demand_trigger_enabled'
    ];
    return paths.some((path) => {
      const value = _.get(this.brandDetails, path);
      return value === true || value === 'true' || value === 1;
    });
  }

  resolveSelectChannelsButtonFromConfig() {
    this.showSelectChannelsButton = false;
    this.onDemandConfigurations = null;

    if (!this.isOnDemandTriggerVisible()) {
      return;
    }

    const brandId = _.get(this.brandDetails, '_id');
    if (!brandId) {
      return;
    }

    this._verbatim.getCustomerNotifierConfiguration(brandId).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (response: any) => {
        const code = Number(_.get(response, 'data.code'));
        if (code !== 0) {
          this.showSelectChannelsButton = false;
          return;
        }

        const configuration = _.get(response, 'data.configuration')
          || _.get(response, 'data.data.configuration')
          || _.get(response, 'data');

        const onDemandConfig = _.get(
          configuration,
          'conversation_config.feedbacks.on_demand_configurations',
          null
        );
        this.onDemandConfigurations = onDemandConfig;

        const channels = this.extractOnDemandCommunicationChannels(configuration, onDemandConfig);
        this.showSelectChannelsButton = Array.isArray(channels) && channels.length > 1;
        this.refreshOnDemandButtonLabels();
        this.cdr.detectChanges();
      },
      error: () => {
        this.showSelectChannelsButton = false;
      }
    });
  }

  extractOnDemandCommunicationChannels(configuration: any, onDemandConfig: any): string[] {
    const fromOnDemand = _.get(onDemandConfig, 'communication_channels');
    if (Array.isArray(fromOnDemand) && fromOnDemand.length) {
      return fromOnDemand;
    }
    const fromBrand = _.get(configuration, 'communication_channels');
    if (Array.isArray(fromBrand) && fromBrand.length) {
      return fromBrand;
    }
    return [];
  }

  refreshOnDemandButtonLabels() {
    const isNotResponded = this.activeTab === 'not_responded' || this.default_selected_type === 'CFR';
    if (!(this.prepared_responded_list?.length) || !isNotResponded) {
      return;
    }
    const requireConfirmation = false; // Outbox handles Send/Custom/Cancel modal itself
    this.prepared_responded_list = this.prepared_responded_list.map((row: any) => {
      if (!_.has(row, this.onDemandTriggerColumnKey)) {
        return row;
      }
      const expired = !!row.isOnDemandExpired;
      return {
        ...row,
        [this.onDemandTriggerColumnKey]: expired ? 'Expired' : 'Send'
      };
    });
    this.requestsJourneyHeader = (this.requestsJourneyHeader || []).map((column: any) => {
      if (column?.dataKey !== this.onDemandTriggerColumnKey) {
        return column;
      }
      return {
        ...column,
        buttonLabel: 'Send',
        requireConfirmation
      };
    });
  }

  getOnDemandButtonLabel(): string {
    return 'Send';
  }

  onTableAction(event: any) {
    if (!event || event.dataKey !== this.onDemandTriggerColumnKey) {
      return;
    }

    const row = _.get(event, 'row');
    const request = this.resolveLatestOutboxRequest(_.get(row, 'requests'), row);
    if (!request || !this.hasAdhocEventId(request) || row?.isOnDemandSending) {
      return;
    }

    // Expired: open channel panel directly (no choice popup) to review trial history.
    if (row?.isOnDemandExpired || this.isLinkExpired(request.created_date)) {
      this.openChannelSelectionPanel(row, request);
      return;
    }

    // Always show Send / Custom / Cancel (not the table Yes/Don't continue modal).
    this.openOnDemandChoiceModal(row, request);
  }

  openOnDemandChoiceModal(row: any, request: any) {
    const latestRequest = this.resolveLatestOutboxRequest(request, row);
    // Highlight as soon as the choice popup opens.
    this.setOnDemandRowHighlight(_.get(latestRequest, 'adhoc_event_id'), row);
    this.pendingOnDemandChoiceRow = row;
    this.pendingOnDemandChoiceRequest = latestRequest;
    this.showOnDemandChoiceModal = true;
    this.cdr.detectChanges();
  }

  closeOnDemandChoiceModal() {
    this.showOnDemandChoiceModal = false;
    this.pendingOnDemandChoiceRow = null;
    this.pendingOnDemandChoiceRequest = null;
  }

  onOnDemandChoiceCancel() {
    this.closeOnDemandChoiceModal();
    // Cancel ends the in-progress highlight for this row.
    this.clearOnDemandRowHighlight();
  }

  onOnDemandChoiceSend() {
    const row = this.pendingOnDemandChoiceRow;
    const request = this.resolveLatestOutboxRequest(this.pendingOnDemandChoiceRequest, row);
    this.closeOnDemandChoiceModal();
    if (!row || !request) {
      return;
    }
    this.triggerOnDemandRequest(row, request);
  }

  onOnDemandChoiceCustom() {
    const row = this.pendingOnDemandChoiceRow;
    const request = this.resolveLatestOutboxRequest(this.pendingOnDemandChoiceRequest, row);
    this.closeOnDemandChoiceModal();
    if (!row || !request) {
      return;
    }
    this.openChannelSelectionPanel(row, request);
  }

  openChannelSelectionPanel(row: any, request: any) {
    // Prefer store copy so post-send trial updates show without CFR list refresh.
    const latestRequest = _.cloneDeep(this.resolveLatestOutboxRequest(request, row));
    this.setOnDemandRowHighlight(_.get(latestRequest, 'adhoc_event_id'), row);
    this.selectedRowForChannelSend = row;
    this.selectedRequestForChannelSend = latestRequest;
    this.channelPanelTagContext = this.resolveChannelPanelTagContext(latestRequest, row);
    this.channelPanelRequestDeadlineAt = this.getLinkExpiryDate(latestRequest?.created_date);
    this.channelPanelRequestDeadlineAbsolute = this.formatLinkExpiryAbsolute(this.channelPanelRequestDeadlineAt);
    this.channelSelectionPanelVisible = true;

    // Refresh config when opening panel so trial sections stay current.
    if (!this.onDemandConfigurations) {
      this.loadCustomerNotifierConfigurationForPanel();
    }
  }

  /**
   * Table rows are deep-cloned; after on-demand send, prefer outboxRequestsData.
   * Falls back to the prepared list / clicked request when the store entry is missing.
   */
  resolveLatestOutboxRequest(request?: any, row?: any): any {
    const clicked = request || row?.requests;
    const id = clicked?.adhoc_event_id ?? row?.requests?.adhoc_event_id;
    if (id == null || id === '') {
      return clicked;
    }

    const fromStore = _.find(this.outboxRequestsData, (item: any) => {
      return String(item?.adhoc_event_id) === String(id);
    });
    if (fromStore) {
      return fromStore;
    }

    const fromPrepared = _.find(this.prepared_responded_list, (item: any) => {
      return String(_.get(item, 'requests.adhoc_event_id')) === String(id);
    });
    return _.get(fromPrepared, 'requests') || clicked;
  }

  /**
   * Tag search context for channel panel: use selected search field only if it is a tag_*,
   * and take the value from the selected request/row (not the search box).
   */
  resolveChannelPanelTagContext(request: any, row: any): { label: string; value: string } | null {
    const fieldId = this.defaultSelectedField?.field_id;
    if (!fieldId || !String(fieldId).startsWith('tag_')) {
      return null;
    }

    let value = _.get(request, fieldId);
    if (value == null || value === '' || value === 'NA') {
      value = _.get(row, fieldId);
    }
    if (value == null || value === '' || value === 'NA') {
      return null;
    }

    return {
      label: this.defaultSelectedField.field_text || fieldId,
      value: String(value)
    };
  }

  viewRequestDetailsFromChannelPanel() {
    const request = this.selectedRequestForChannelSend;
    if (!request) {
      return;
    }
    const latest = this.resolveLatestOutboxRequest(request);
    this.selectedChannelDetail = _.cloneDeep(latest);
    this.OutboxDetailsVisible = true;
    this.cdr.detectChanges();
  }

  closeChannelSelectionPanel() {
    if (this.isChannelPanelSending) {
      return;
    }
    this.channelSelectionPanelVisible = false;
    this.isChannelConfigLoading = false;
    this.selectedRowForChannelSend = null;
    this.selectedRequestForChannelSend = null;
    this.channelPanelTagContext = null;
    this.channelPanelRequestDeadlineAt = null;
    this.channelPanelRequestDeadlineAbsolute = null;
    // Cancel / close before Send ends the lifecycle highlight.
    this.clearOnDemandRowHighlight();
  }

  loadCustomerNotifierConfigurationForPanel() {
    const brandId = _.get(this.selectedRequestForChannelSend, 'brand_id') || _.get(this.brandDetails, '_id');
    if (!brandId) {
      this._toast.showPopup('ERROR', 'Error', 'Brand id is required to load channel configuration.', 7000);
      this.closeChannelSelectionPanel();
      return;
    }

    this.isChannelConfigLoading = true;
    this._verbatim.getCustomerNotifierConfiguration(brandId).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (response: any) => {
        this.isChannelConfigLoading = false;
        const code = Number(_.get(response, 'data.code'));
        const message = (
          _.get(response, 'data.error_message')
          || _.get(response, 'data.message')
          || 'Unable to load channel configuration.'
        ).toString();

        if (code === 0) {
          const configuration = _.get(response, 'data.configuration')
            || _.get(response, 'data.data.configuration')
            || _.get(response, 'data');
          this.onDemandConfigurations = _.get(
            configuration,
            'conversation_config.feedbacks.on_demand_configurations',
            null
          );
          this.cdr.detectChanges();
          return;
        }

        this.showCustomerNotifierConfigToast(code, message);
        this.closeChannelSelectionPanel();
      },
      error: () => {
        this.isChannelConfigLoading = false;
        this._toast.showPopup('ERROR', 'Error', 'Unable to connect the server', 7000);
        this.closeChannelSelectionPanel();
      }
    });
  }

  showCustomerNotifierConfigToast(code: number, message: string) {
    switch (code) {
      case 4100:
        this._toast.showPopup('WARN', 'Invalid Request', message, 7000);
        break;
      case 4053:
        this._toast.showPopup('ERROR', 'Authorization Failed', message || 'Authorization Failed', 7000);
        break;
      case 4054:
        this._toast.showPopup('ERROR', 'Not Found', message || 'Brand details not found.', 7000);
        break;
      case 4051:
        this._toast.showPopup('ERROR', 'Error', message || 'Unhandled Error.', 7000);
        break;
      default:
        this._toast.showPopup('ERROR', 'Error', message || 'Unable to load channel configuration.', 7000);
        break;
    }
  }

  onChannelSelectionSend(payload: { trialNumber: number; channels: string[] }) {
    const row = this.selectedRowForChannelSend;
    const request = this.resolveLatestOutboxRequest(this.selectedRequestForChannelSend, row);
    if (!request || !row || !payload?.channels?.length) {
      return;
    }

    this.isChannelPanelSending = true;
    this.channelSelectionPanelVisible = false;
    this.channelPanelTagContext = null;
    this.channelPanelRequestDeadlineAt = null;
    this.channelPanelRequestDeadlineAbsolute = null;
    this.triggerOnDemandRequest(row, request, payload.channels);
  }

  /**
   * Send notification → wait 4s → fetch latest CFR → update row + open side panel.
   * Handles on_demand_dispatch response codes from API.
   * Phase 2: optional communication_channels from channel selection panel.
   */
  triggerOnDemandRequest(row: any, request: any, communicationChannels?: string[]) {
    const adhocEventId = _.get(request, 'adhoc_event_id');
    if (_.isNil(adhocEventId) || adhocEventId === '') {
      return;
    }

    this.setRowSendingState(adhocEventId, true, row);

    const dispatchBody: any = {
      adhoc_event_id: adhocEventId,
      brand_id: _.get(request, 'brand_id') || _.get(this.brandDetails, '_id')
    };
    if (communicationChannels?.length) {
      dispatchBody.communication_channels = communicationChannels;
    }

    console.log('dispatchBody', dispatchBody);

    this._verbatim.onDemandDispatch(dispatchBody).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (response: any) => {
        this.isChannelPanelSending = false;
        const code = Number(_.get(response, 'data.code'));
        const message = (
          _.get(response, 'data.error_message')
          || _.get(response, 'data.message')
          || 'Unable to send notification.'
        ).toString();

        if (code === 0) {
          this._toast.showPopup('SUCCESS', 'Success', message || 'Notification sent successfully.', 10000);
          setTimeout(() => {
            this.fetchLatestCfrByAdhocEventId(adhocEventId, request, {
              openPanel: true,
              clearSendingState: true,
              source: 'send',
              tableRow: row
            });
          }, 4000);
          return;
        }

        this.setRowSendingState(adhocEventId, false, row);
        this.clearOnDemandRowHighlight();
        this.showOnDemandDispatchToast(code, message);
      },
      error: () => {
        this.isChannelPanelSending = false;
        this.setRowSendingState(adhocEventId, false, row);
        this.clearOnDemandRowHighlight();
        this._toast.showPopup('ERROR', 'Error', 'Unable to connect the server', 5000);
      }
    });
  }

  /**
   * Toast mapping for on_demand_dispatch_post codes.
   * 0 success | 1 business/validation | 4100 invalid params | 4053 auth |
   * 4054 not found | 4051 config/unhandled | 4052 internal/SQS
   */
  showOnDemandDispatchToast(code: number, message: string) {
    const normalized = (message || '').toLowerCase();

    if (normalized.includes('user_already_responded')) {
      this._toast.showPopup('INFO', 'Info', 'The request has been rated', 5000);
      this.clearOnDemandRowHighlight();
      if (this.OutboxDetailsVisible) {
        this.closeOutboxDetailPanel();
      }
      return;
    }

    switch (code) {
      case 1: // pipeline / business failures (cooldown, timing, limits, channels, etc.)
        this._toast.showPopup('WARN', 'Warning', message, 10000);
        break;
      case 4100: // required/invalid body params
        this._toast.showPopup('WARN', 'Invalid Request', message, 10000);
        break;
      case 4053:
        this._toast.showPopup('ERROR', 'Authorization Failed', message || 'Authorization Failed', 10000);
        break;
      case 4054:
        this._toast.showPopup('ERROR', 'Not Found', message, 10000);
        break;
      case 4051:
        this._toast.showPopup('ERROR', 'Configuration Error', message, 10000);
        break;
      case 4052:
        this._toast.showPopup('ERROR', 'Internal Error', message || 'Internal error.', 10000);
        break;
      default:
        this._toast.showPopup('ERROR', 'Error', message || 'Unable to send notification.', 10000);
        break;
    }
  }

  /**
   * Side-panel refresh: fetch latest CFR for the open request.
   */
  refreshOutboxDetailPanel() {
    const request = this.selectedChannelDetail;
    const adhocEventId = _.get(request, 'adhoc_event_id');
    if (_.isNil(adhocEventId) || adhocEventId === '') {
      this._toast.showPopup('ERROR', 'Error', 'Unable to refresh this request.', 5000);
      return;
    }

    this.isDetailPanelRefreshing = true;
    this.fetchLatestCfrByAdhocEventId(adhocEventId, request, {
      openPanel: true,
      clearSendingState: false,
      source: 'refresh'
    });
  }

  /**
   * Shared get-latest-CFR by adhoc_event_id. Updates only the matching row when present.
   */
  fetchLatestCfrByAdhocEventId(
    adhocEventId: any,
    clickedRequest: any,
    options: {
      openPanel?: boolean;
      clearSendingState?: boolean;
      source?: 'send' | 'refresh';
      tableRow?: any;
    } = {}
  ) {
    const { openPanel = false, clearSendingState = false, source = 'send', tableRow } = options;

    this._verbatim.getRequestByAdhocEventId({ adhoc_event_id: adhocEventId }).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (response: any) => {
        if (clearSendingState) {
          this.setRowSendingState(adhocEventId, false, tableRow);
          this.clearOnDemandRowHighlight();
        }
        if (source === 'refresh') {
          this.isDetailPanelRefreshing = false;
        }

        if (response?.data?.code === 0 && _.get(response, 'data.request')) {
          const latestRequest = this.extractFeedbackRequestFromResponse(response, clickedRequest);
          if (latestRequest) {
            const matchAdhocEventId = latestRequest.adhoc_event_id ?? adhocEventId;
            this.updatePreparedRowByAdhocEventId(matchAdhocEventId, latestRequest);
            if (openPanel) {
              this.selectedChannelDetail = _.cloneDeep(latestRequest);
              this.OutboxDetailsVisible = true;
              this.cdr.detectChanges();
            }
          } else {
            this.handleRatedOrMissingCfr(source);
          }
        } else {
          this.handleRatedOrMissingCfr(source);
        }
      },
      error: () => {
        if (clearSendingState) {
          this.setRowSendingState(adhocEventId, false, tableRow);
          this.clearOnDemandRowHighlight();
        }
        if (source === 'refresh') {
          this.isDetailPanelRefreshing = false;
        }
        this._toast.showPopup('ERROR', 'Error', 'Unable to connect the server', 5000);
      }
    });
  }

  handleRatedOrMissingCfr(source: 'send' | 'refresh') {
    this._toast.showPopup('INFO', 'Info', 'The request has been rated', 5000);
    if (source === 'send') {
      this.clearOnDemandRowHighlight();
    }
    if (source === 'refresh' || this.OutboxDetailsVisible) {
      this.closeOutboxDetailPanel();
    }
  }

  setRowSendingState(adhocEventId: any, isSending: boolean, tableRow?: any) {
    const rowIndex = _.findIndex(this.prepared_responded_list, (row: any) => {
      return String(_.get(row, 'requests.adhoc_event_id')) === String(adhocEventId);
    });
    if (rowIndex >= 0) {
      // Keep parent row in sync without replacing the array (avoids table scroll reset).
      this.prepared_responded_list[rowIndex].isOnDemandSending = isSending;
    }
    // Table rows are deep-cloned; also update the emitted row so the Send loader shows.
    if (tableRow) {
      tableRow.isOnDemandSending = isSending;
    }
    this.cdr.detectChanges();
  }

  /**
   * Highlight the row whose on-demand flow is active (panel open / send in progress).
   */
  setOnDemandRowHighlight(adhocEventId: any, tableRow?: any) {
    if (adhocEventId == null || adhocEventId === '') {
      return;
    }
    if (String(this.highlightedOnDemandAdhocEventId) === String(adhocEventId)) {
      if (tableRow) {
        this.highlightedOnDemandTableRow = tableRow;
        tableRow.isOnDemandLifecycleActive = true;
      }
      this.cdr.detectChanges();
      return;
    }
    this.clearOnDemandRowHighlight();
    this.highlightedOnDemandAdhocEventId = adhocEventId;
    this.highlightedOnDemandTableRow = tableRow || null;
    this.applyOnDemandRowHighlight(true, adhocEventId, tableRow);
  }

  clearOnDemandRowHighlight() {
    if (this.highlightedOnDemandAdhocEventId == null) {
      return;
    }
    this.applyOnDemandRowHighlight(
      false,
      this.highlightedOnDemandAdhocEventId,
      this.highlightedOnDemandTableRow
    );
    this.highlightedOnDemandAdhocEventId = null;
    this.highlightedOnDemandTableRow = null;
  }

  applyOnDemandRowHighlight(isActive: boolean, adhocEventId: any, tableRow?: any) {
    const rowIndex = _.findIndex(this.prepared_responded_list, (row: any) => {
      return String(_.get(row, 'requests.adhoc_event_id')) === String(adhocEventId);
    });
    if (rowIndex >= 0) {
      this.prepared_responded_list[rowIndex].isOnDemandLifecycleActive = isActive;
    }
    if (tableRow) {
      tableRow.isOnDemandLifecycleActive = isActive;
    }
    this.cdr.detectChanges();
  }

  /**
   * Merge onto clicked row so tag_private_* display fields stay unless API refreshes them.
   */
  extractFeedbackRequestFromResponse(response: any, clickedRequest: any) {
    const latestRequest = _.get(response, 'data.request');
    if (!latestRequest || _.isEmpty(latestRequest)) {
      return null;
    }

    return {
      ...clickedRequest,
      ...latestRequest,
      adhoc_event_id: latestRequest.adhoc_event_id ?? clickedRequest.adhoc_event_id
    };
  }

  /**
   * Replace only the prepared table row whose requests.adhoc_event_id matches.
   * Phase 1: keep prepared_responded_list array reference to avoid table scroll reset.
   */
  updatePreparedRowByAdhocEventId(adhocEventId: any, latestRequest: any) {
    const rowIndex = _.findIndex(this.prepared_responded_list, (row: any) => {
      return String(_.get(row, 'requests.adhoc_event_id')) === String(adhocEventId);
    });

    if (rowIndex < 0) {
      return;
    }

    const previousRow = this.prepared_responded_list[rowIndex] || {};
    const mappedRow = this.buildOutboxTableRow(latestRequest, 'cfr');
    // Preserve loader state + keep same row object identity where possible via Object.assign.
    mappedRow.isOnDemandSending = false;
    Object.keys(previousRow).forEach((key) => {
      if (!(key in mappedRow)) {
        delete previousRow[key];
      }
    });
    Object.assign(previousRow, mappedRow);
    this.prepared_responded_list[rowIndex] = previousRow;

    const requestIndex = _.findIndex(this.outboxRequestsData, (item: any) => {
      return String(_.get(item, 'adhoc_event_id')) === String(adhocEventId);
    });
    if (requestIndex >= 0) {
      this.outboxRequestsData[requestIndex] = latestRequest;
    }

    this.cdr.detectChanges();
  }

  // based on the tab selection it's highlight the active tab and change the page url accordingly
  toggleTab(tab: string): void {
    this.clearOnDemandRowHighlight();
    this.isDataLoaded = false;
    this.prepared_responded_list = [];
    this.prepared_non_responded_list = [];
    this.activeTab = tab;
    this.default_selected_type = this.activeTab === 'responded' ? 'CFRA' : 'CFR';
    this.requestType = this.activeTab === 'responded' ? 'CFRA' : 'CFR';
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: tab },
      queryParamsHandling: 'merge'
    });
    if(this.defaultSelectedField.field_id.startsWith('tag_')){
      this.clearSearchBox();
      this.params = {};
      this.defaultSelectedField = this.searchAvailableOnList[1];
    }
    this.is_cohort_based_search_enabled = this.isCohortBasedSearchEnabled();
    this.searchAvailableOnList = this.getSearchAvailableOnList();
    this.istabchange = true;
    if (this.isRequiredparameterrecive) {
      this.loadData(this.requestType);
    }
  }


  showChannelStatus($event) {
    // Table rows are deep-cloned; prefer outboxRequestsData (updated on Send).
    const latest = this.resolveLatestOutboxRequest($event?.row?.['requests'], $event?.row);
    this.selectedChannelDetail = _.cloneDeep(latest);
    this.OutboxDetailsVisible = true;
  }

  closeOutboxDetailPanel() {
    this.OutboxDetailsVisible = false;
    this.isDetailPanelRefreshing = false;
    this.selectedChannelDetail = null;
  }

  openNewRequest() {
    // Set popup visibility to true
    this.newReqestPanelVisible = true;
  }

  closeNewRequestPanel() {
    this.newReqestPanelVisible = false;
  }
  loadData(requst_type) {
    this.total_count_of_data = 0;
    this.pagingDetails.pageNumber = 1;
    this.loadDataByType(requst_type)
  }


  loadDataByType(requst_type) {
    this.isDataLoaded = false;
    this.default_selected_type = requst_type;
    this.prepared_responded_list = [];
    this.prepared_non_responded_list = [];
    this.pagingDetails.pageNumber = 1;
    if (requst_type === 'CFR') {
      this.getCFR();
    } else {
      this.getCFRA();
    }
  }

  // Get responded data 
  getCFRA() {
    this.getListByType(true, (responded_list) => {
      this.prepareDetails(responded_list, 'cfra')
    })
  }

  // Refresh the data based on selected type(CFR and CFRA)
  refreshData() {
    this.clearOnDemandRowHighlight();
    this.isDataLoaded = false
    this.loadData(this.default_selected_type)
  }

  // Get NoN responded data
  getCFR() {
    this.getListByType(false, (responded_list) => {
      this.prepareDetails(responded_list, 'cfr')
    })
  }

  // Get reponded and non responded list 
  getListByType(is_archived, cb) {
    this.isDataLoaded = false;
    // Always send page_number as 1
    this.params['brand_id'] = this.brandDetails._id;
    this.params['version'] = 'v1';
    this.params['limit'] = this.pagingDetails.pageSize;
    // this.params['page_number'] = this.pagingDetails.pageNumber;
    this.params['page_number'] = 1;
    this.params['is_archived'] = is_archived;
    this.params['to'] = _.get(Helpers, "datePicker.endDate");
    this.params['from'] = _.get(Helpers, "datePicker.startDate");
    this.params = this.getHierarchyParams(this.params);
    this._verbatim.getListForSentTab(this.params).pipe(
      takeUntilDestroyed(this.destroyRef),
      finalize(() => {
        // Clean-up keys
        Object.keys(this.params).forEach(key => {
          if (key.startsWith('hierarchy_stack')) {
            delete this.params[key];
          }
        });
      })
    ).subscribe({
      next: (outboxDetail) => {
        if (outboxDetail && outboxDetail['data']?.['code'] === 0) {
          cb(outboxDetail['data']);
        } else {
          cb([]); // Still call prepareDetails with empty array
        }
      },

      error: (err) => {
        console.error("API error", err);
        cb([]); // still prepare with empty list
      }
    });
  }



  prepareDetails(data, type) {
    // this.isDataLoaded=true
    this.showOnDemandTriggerColumn = false;
    if (data && data['requests'] && data['requests'].length > 0 && data['shops'] && data['users'] && data['total'] > 0) {
      if (type === 'cfr') {
        this.showOnDemandTriggerColumn = _.some(data['requests'], (request: any) => this.hasAdhocEventId(request));
      }
      this.total_count_of_data = data['total'];
      // If page_number is 1, set pageNumber to number of records, else use current logic
      if (data['page_number'] === 1) {
        this.updatePagingDetails(this.total_count_of_data, data['requests'].length);
      } else {
        this.updatePagingDetails(this.total_count_of_data, this.pagingDetails.pageNumber);
      }
      this.outboxRequestsData = data['requests']
      this.prepared_responded_list = _.map(data['requests'], (cfra) => this.buildOutboxTableRow(cfra, type))
    } else {
      this.isDataLoaded = true
      this.prepared_responded_list = [];
      this.pagingDetails = {
        start: 0,
        end: 0,
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        totalpages: 1
      }
    }
    this.generateDynamicColunms(this.prepared_responded_list, type)
    if (type === 'cfr') {
      this.refreshOnDemandButtonLabels();
    }
    this.isDataLoaded = true;
    this.cdr.detectChanges();
  }

  /**
   * Maps a single CFR/CFRA request into a prepared table row.
   * Shared by full list load and single-row on-demand refresh.
   */
  buildOutboxTableRow(cfra: any, type: string) {
    const data: any = {};

    // Check if user masking enabled or not
    let is_restrict_user_details = _.get(this.brandDetails, 'is_restrict_user_details', false);
    let is_restrict_partial_user_details = _.get(this.brandDetails, 'is_restrict_partial_user_details', false);
    if (is_restrict_user_details == true && is_restrict_partial_user_details == false) {
      this.searchBoxVisible = false;
      data['Name'] = "Anonymous";
      data['Email Address'] = "NA";
      data['Mobile Number'] = "NA";
      data['Whatsapp Number'] = "NA";
    } else {
      this.searchBoxVisible = true;
      data['Name'] = (cfra['tag_private_user_name']) ? cfra['tag_private_user_name'] : "Anonymous";
      data['Email Address'] = (cfra['tag_private_email_address']) ? cfra['tag_private_email_address'] : "NA";
      data['Mobile Number'] = (cfra['tag_private_phone_number']) ? cfra['tag_private_phone_number'] : "NA";
      data['Whatsapp Number'] = (cfra['tag_private_whatsapp_number']) ? cfra['tag_private_whatsapp_number'] : "NA";
    }
    if (this.fieldDefinitionsMap && !_.isEmpty(this.fieldDefinitionsMap)) {
      _.each(this.fieldDefinitionsMap, (field: any, key: string) => {
        data[key] = cfra[key] ? cfra[key] : "NA";
      });
    }

    const trials = cfra['trials'] || [];
    const creator_name = cfra['tag_private_request_created_by_name'] || cfra['tag_private_request_created_by_username'];
    data['Creator'] = creator_name ? creator_name : ((cfra['tag_private_job_id']) ? "System Upload" : "NA");
    data['trials'] = trials;
    if (type == 'cfra') {
      // data['Total Attempts'] = (cfra['attempts']) ? cfra['attempts'] : "NA";
      data['Request Created Date'] = this._helpers.getTimeByOffset(this.brandOffsetName["__zone_symbol__value"]['offset'], cfra['feedback_request_date'], "DD MMM 'YY HH:mm");
      data['Responded Date'] = this._helpers.getTimeByOffset(this.brandOffsetName["__zone_symbol__value"]['offset'], cfra['created_date'], "DD MMM 'YY HH:mm");
      data['Responded On'] = this.getRespondedDetails(cfra['interaction']);
    } else if (type == 'cfr') {
      data['Request Created Date'] = this._helpers.getTimeByOffset(this.brandOffsetName["__zone_symbol__value"]['offset'], cfra['created_date'], "DD MMM 'YY HH:mm");
      if (cfra['_id'] != null) {
        data['Link'] = _.get(this.brandDetails, "conversation_config.feedbacks.url") + 'v2/' + cfra['_id'] + "?utm_medium=link&utm_term=trial_1";
      }
      if (this.showOnDemandTriggerColumn && this.hasAdhocEventId(cfra)) {
        const expired = this.isLinkExpired(cfra['created_date']);
        data.isOnDemandExpired = expired;
        data[this.onDemandTriggerColumnKey] = expired ? 'Expired' : 'Send';
      }
    }
    data['Last Attempted Date'] = trials.length > 0 ? this.getLastAttemptDate(trials) : "NA";
    data['Delivery Status'] = this.getDeliveryStatusDetails(cfra);
    if (_.get(this.brandDetails, "is_single_touchpoint_setup")) {
      data['Touchpoint'] = (cfra['tag_private_group_hierarchy_0_id']) ? cfra['tag_private_group_hierarchy_0_id'] : "NA";
    } else {
      data['Touchpoint'] = "Static Project"
    }
    if (cfra?.is_excluded_from_analytics) {
      data['info'] = {
        Name: "Exculded from statistics"
      }
    }

    data['requests'] = cfra;
    return data;
  }

  // Set hierarchy stack parameters
  getHierarchyParams(params) {
    if (this.hierarchyStack) {
      this.hierarchyStack.forEach((currentHierarchy, index) => {
        if (currentHierarchy?.field_id) {
          params[`hierarchy_stack[${index}][field_id]`] = currentHierarchy.field_id;
          const groupKey = currentHierarchy.group_key?.[0];
          if (groupKey) {
            params[`hierarchy_stack[${index}][group_key][0]`] = groupKey;
          }
        }
      });
    }
    return params;
  }

  getRespondedDetails(interaction) {
    const responded_on = _.find(interaction, { interaction_type: 'rate' });
    if (responded_on && responded_on['utm_medium'] && responded_on['utm_term']) {
      let resAtmpt = responded_on['utm_term'].match(/(\d+)/);  //no. of attempts 
      if (resAtmpt && resAtmpt[0]) {
        return `Attempt ${resAtmpt[0]} . ${this.capitalizeFirstLetter(responded_on['utm_medium'])}`;
      }
    }
    return "NA";
  }

  getLastAttemptDate(trials) {
    let last_attempt_date;
    if (trials && trials.length > 0) {
      last_attempt_date = trials[trials.length - 1].attempt_date ?
        this._helpers.getTimeByOffset(this.brandOffsetName["__zone_symbol__value"]['offset'], trials[trials.length - 1].attempt_date, "DD MMM 'YY HH:mm") : 'N/A'
      for (var i = trials.length - 1; i >= 0; i--) {
        trials[i].attempt_date = trials[i].attempt_date ? this._helpers.getTimeByOffset(this.brandOffsetName["__zone_symbol__value"]['offset'], trials[i].attempt_date, "DD MMM 'YY HH:mm") : "N/A";
      }
    }
    return last_attempt_date;
  }

  getLastAttemptDetails(trials) {
    if (trials && trials.length > 0) {
      const lastAttemptDetails = _.orderBy(trials, ['attempt'], ['asc']);
      const last_object = lastAttemptDetails.length - 1;
      return lastAttemptDetails[last_object];
    } else {
      return "NA";
    }
  }

  getDeliveryStatusTooltip(
    channel: string,
    channelData: any,
    trial: any,
    request: any
  ): string {

    const channelName =
      channel === 'phone' ? 'SMS' :
        channel === 'email' ? 'Email' :
          channel === 'link' ? 'Link' : 'WhatsApp';

    const errorDescriptions: Record<string, string> =
      OutboxDetailPanelComponent.getErrorDescription;

    const resolveError = (value: any): string | null => {
      if (value === null || value === undefined || value === '') {
        return null;
      }

      return errorDescriptions[String(value)] || String(value);
    };

    // Trial-level errors take precedence when the channel is absent.
    if (!channelData && trial?.error) {
      return resolveError(trial.error) || 'N/A';
    }

    if (!channelData) {
      const incorrectField =
        channel === 'phone' ? 'is_phone_number_incorrect' :
          channel === 'email' ? 'is_email_address_incorrect' :
            'is_whatsapp_number_incorrect';

      return request?.[incorrectField] === false
        ? 'Not Configured'
        : 'N/A';
    }

    const trialDeliveryStatus =
      channel === 'phone' ? trial?.sms_delivery_status :
        channel === 'email' ? trial?.email_delivery_status :
          undefined;

    const isDelivered =
      channelData.sent === true &&
      (
        channelData.delivery_status == 1 ||
        trialDeliveryStatus == 1 ||
        channelData.delivered === true
      );

    if (isDelivered) {
      return `${channelName} delivered successfully`;
    }

    // Preserve the error priority from the older dashboard.
    const error =
      resolveError(channelData.error_string) ||
      resolveError(channelData.error_desc) ||
      resolveError(channelData.error);

    if (error) {
      return error;
    }

    const deliveryStatus =
      channelData.delivery_status ?? trialDeliveryStatus;

    if (deliveryStatus !== null && deliveryStatus !== undefined) {
      return this.deliveryStatusDescriptions[Number(deliveryStatus)]
        || `Delivery Status: ${deliveryStatus}`;
    }

    return channelData.sent === true ? 'Request Sent' : 'N/A';
  }

  getDeliveryStatusDetails(request: any): any[] {
    const trials = request?.trials || [];

    const lastTrial = trials.find(
      (trial: any) =>
        String(trial.attempt) === String(request?.last_trial_attempt)
    );

    const notifyChannel = String(request?.notify_channel || '').toLowerCase();

    const communicationChannels = (
      Array.isArray(request?.communication_channels)
        ? request.communication_channels
        : []
    ).map((channel: string) => String(channel).toLowerCase());

    const hasCommunicationChannel = (channel: string): boolean =>
      communicationChannels.includes(channel);

    const hasNotifyChannel = (channel: string): boolean =>
      notifyChannel.includes(channel);

    const hasLinkInTrials = trials.some((trial: any) =>
      trial?.channels?.some(
        (item: any) => item?.channel?.toLowerCase() === 'link'
      )
    );

    const channels: string[] = [];

    // SMS visibility
    if (
      hasNotifyChannel('phone') ||
      hasNotifyChannel('all') ||
      hasCommunicationChannel('phone')
    ) {
      channels.push('phone');
    }

    // Email visibility
    if (
      hasNotifyChannel('email') ||
      hasNotifyChannel('all') ||
      hasCommunicationChannel('email')
    ) {
      channels.push('email');
    }

    // WhatsApp visibility
    if (
      hasCommunicationChannel('whatsapp') ||
      request?.whatsapp_channel === true
    ) {
      channels.push('whatsapp');
    }

    // Link visibility
    if (
      request?.link_channel === true ||
      lastTrial?.channels?.some(
        (item: any) => item?.channel?.toLowerCase() === 'link'
      )
    ) {
      channels.push('link');
    }

    return channels.map(channel => {
      // uncomment if need last attempt status
      // const channelData = lastTrial?.channels?.find(
      //   (item: any) =>
      //     item?.channel?.toLowerCase() === channel ||
      //     (
      //       channel === 'phone' &&
      //       item?.channel?.toLowerCase() === 'sms'
      //     )
      // );
      const channelData = [...trials]
        .sort((a: any, b: any) =>
          Number(b.attempt) - Number(a.attempt)
        )
        .flatMap((trial: any) => trial.channels || [])
        .find((item: any) => {
          const itemChannel = String(item.channel || '').toLowerCase();

          return itemChannel === channel ||
            (channel === 'phone' && itemChannel === 'sms');
        });

      let status = 'not_configured';
      // uncomment if need last attempt status
      // if (channelData) {
      //   if (channelData.delivered === true) {
      //     status = 'delivered';
      //   } else if (
      //     channelData.delivered === false ||
      //     channelData.sent === false
      //   ) {
      //     status = 'failed';
      //   } else {
      //     status = 'pending';
      //   }
      // }
      if (channelData) {
        if (
          channelData.delivered === true ||
          channelData.delivery_status === 1
        ) {
          status = 'delivered';
        } else if (
          channelData.delivered === false ||
          channelData.sent === false ||
          channelData.delivery_status === 2
        ) {
          status = 'failed';
        } else if (
          channelData.attempted === true ||
          channelData.sent === true
        ) {
          status = 'pending';
        }
      }

      return {
        channel,
        status,
        delivery_status: channelData?.delivery_status,
        original_dlr_status: channelData?.original_dlr_status,
        tooltip: this.getDeliveryStatusTooltip(
          channel,
          channelData,
          lastTrial,
          request
        )
      };
    });
  }


  /**
   * Fixed table columns. The row data and cohort tooltip metadata remain
   * unchanged, but visible columns no longer depend on field definitions
   * or on the shape of the first API result.
   */
  generateDynamicColunms(_data: any[], typeofdata: string) {
    const baseColumns: any[] = [
      {
        header: 'Customer Details',
        dataKey: 'Name',
        dataType: 'string',
        width: '35%',
        isInfoIconVisible: true,
        piiDescriptionFields: ['Email Address', 'Mobile Number', 'Whatsapp Number'],
        cohortDescriptionFields: this.cohortFields.slice(0, 3),
        clickable: true,
        tooltipEnabled: false,
        order: 1,
        style: {
          headerTextAlign: 'left',
          cellTextAlign: 'left',
          fontWeight: 600,
          width: '35%'
        }
      },
      {
        header: 'Request Created Date',
        dataKey: 'Request Created Date',
        dataType: 'string',
        width: '20%',
        clickable: true,
        order: 2,
        style: {
          width: '10%'
        }
      },
      {
        header: 'Last Attempted Date',
        dataKey: 'Last Attempted Date',
        dataType: 'string',
        width: '20%',
        clickable: true,
        order: 5,
        style: {
          width: '10%'
        }
      }
    ];

    // The on-demand action stays first for eligible CFR requests.
    if (typeofdata === 'cfr' && this.showOnDemandTriggerColumn) {
      baseColumns.unshift({
        header: this.onDemandTriggerColumnKey,
        dataKey: this.onDemandTriggerColumnKey,
        isHtmlExist: true,
        source_type: 'on_demand_trigger',
        buttonLabel: 'Send',
        clickable: false,
        requireConfirmation: false,
        confirmMessageKey: 'OUTBOX_ON_DEMAND_SEND_ALERT',
        ellipsisEnabled: false,
        sortingEnabled: false,
        width: '160px',
        order: 0,
        style: {
          headerTextAlign: 'left',
          cellTextAlign: 'left',
          width: '160px'
        }
      });
    }
    if (typeofdata === "cfr") {
      baseColumns.push({
        header: 'Delivery Status',
        dataKey: 'Delivery Status',
        dataType: 'object',
        width: '180px',
        isHtmlExist: true,
        source_type: 'delivery_status',
        ellipsisEnabled: false,
        sortingEnabled: false,
        clickable: false,
        tooltipEnabled: false,
        order: 3,
        style: {
          headerTextAlign: 'center',
          cellTextAlign: 'center',
          width: '180px',
          fontWeight: 400
        }
      })
    }
    if (typeofdata === 'cfra') {
      baseColumns.push({
        header: 'Responded Date',
        dataKey: 'Responded Date',
        dataType: 'string',
        width: '20%',
        clickable: true,
        order: 3,
        style: {
          width: '10%'
        }
      }, {
        header: 'Responded On',
        dataKey: 'Responded On',
        dataType: 'string',
        width: '20%',
        clickable: true,
        order: 4,
        style: {
          width: '10%'
        }
      });
    }
    const hasLink = typeofdata === 'cfr' && _data?.some((row: any) => row['Link'] && row['Link'] !== 'NA');

    if (hasLink) {
      baseColumns.push({
        header: 'Link',
        dataKey: 'Link',
        enabled: true,
        isHtmlExist: true,
        source_type: 'outbox',
        style: {
          width: '10%'
        }
      });
    }
    const hasSendColumn = typeofdata === 'cfr' && this.showOnDemandTriggerColumn;
    this.requestsJourneyHeader = baseColumns.map((column, index) => ({
      is_deviation_enabled: false,
      enabled: true,
      ellipsisEnabled: true,
      fixed: !hasSendColumn && index === 0,
      clickable: false,
      style: {
        headerTextAlign: 'left',
        cellTextAlign: 'left',
        fontWeight: 400
      },
      ...column,
      // order: index + 1
    }));

    this.isDataAvailable = true;
  }

  changeFilterField(field) {
    this.defaultSelectedField = field;
    this.showFilterFields = false;
  }

  getSearchText(searchText: string) {
    let splitted_text: string[] = [];
    let new_text: string | null = null;
    let text: string = (searchText) ? searchText.toLowerCase().trim() : searchText.trim();
    if (text.includes('@')) {
      splitted_text = text.split('@');
      new_text = splitted_text[0] + ' @' + splitted_text[1];
      text = new_text;
    }
    if (text.includes('+')) {
      splitted_text = text.split('+');
      new_text = splitted_text[0] + ' +' + splitted_text[1];
      text = new_text;
    }
    return text;
  }

  searchUserByType(event: any) {
    let searchText = event.target.value;
    this.showSearchList = true;
    this.isTextEntered = true;
    // Process the searchText using getSearchText
    searchText = this.getSearchText(searchText);
    if (searchText && searchText != "" && searchText.length > 0) {
      const fieldId = this.defaultSelectedField.field_id;
      const params = {};
      params['brand_id'] = this.brandDetails._id;
      params['order'] = 0;
      params['search_type'] = fieldId;
      params['search_text'] = searchText;
      params['limit'] = 10;
      params['from'] = 0;
      params['to_date'] = _.get(Helpers, "datePicker.endDate");
      params['from_date'] = _.get(Helpers, "datePicker.startDate")
      // this.params['custom_filter_list'] = this.getCustomHierarchyFilters(),

      this._verbatim.getUserDetailsByType(params).pipe(
        takeUntilDestroyed(this.destroyRef)

      ).subscribe((response: any) => {
        // console.log("search result",response)
        this.searchResult = this.processSerchResult(fieldId, response.data);
      });
    } else {
      this.searchResult = {
        options: [{
          'displayText': "Type something to start searching",
          'text': "Type something to start searching",
          'id': '',
          isError: true
        }]
      }
    }
    if (this.searchText.length == 0) {
      this.isTextEntered = false;
      // this.isTextEntered = false;
      // Do not hide the search list here, keep it visible for user guidance
      if (this.params['user_id']) {
        delete this.params['user_id'];
        this.loadDataByType(this.default_selected_type);
      }
    }
  }

  searchCohortBasedRequests(event: any) {
    var tag_based_search = { key: [this.defaultSelectedField.field_id] , value:  event.target.value}
    this.isDataLoaded = false;
    this.isTextEntered = true;
    // Always send page_number as 1
    this.params['brand_id'] = this.brandDetails._id;
    this.params['version'] = 'v1';
    this.params['limit'] = this.pagingDetails.pageSize;
    // this.params['page_number'] = this.pagingDetails.pageNumber;
    this.params['page_number'] = 1;
    this.params['is_archived'] = false;
    this.params['to'] = _.get(Helpers, "datePicker.endDate");
    this.params['from'] = _.get(Helpers, "datePicker.startDate");
    this.params = this.getHierarchyParams(this.params);
    this.params['tag_based_search']= tag_based_search;
    this._verbatim.getListForSentTab(this.params).pipe(
      takeUntilDestroyed(this.destroyRef),
      finalize(() => {
        // Clean-up keys
        Object.keys(this.params).forEach(key => {
          if (key.startsWith('hierarchy_stack')) {
            delete this.params[key];
          }
        });
      })
    ).subscribe({
      next: (outboxDetail) => {
        this.isCohertFilterApplied = true;
        if (outboxDetail && outboxDetail['data']?.['code'] === 0) {
          this.prepareDetails(outboxDetail['data'], 'cfr')
        } else {
          this.prepareDetails([], 'cfr')
        }
      },

      error: (err) => {
        console.error("API error", err);
        this.prepareDetails([], 'cfr')
      }
    });
  }


  getCustomHierarchyFilters() {
    var hierarchyFilters: any = [];
    // this.brandDetails = (this.brandDetails) ? this.brandDetails : Helpers.brandDetails;
    if (this.brandDetails && this.brandDetails.is_single_touchpoint_setup && Helpers.hierarchyStack && Helpers.hierarchyStack.length) {
      _.each(Helpers.hierarchyStack, function (hierarchy) {
        if (hierarchy.field_id && hierarchy.group_key && hierarchy.group_key.length) {
          hierarchyFilters.push({
            "field": hierarchy.field_id,
            "value": hierarchy.group_key[0]
          })
        }
      })
    }
    return hierarchyFilters;
  }

  toggleSearchList() {
    this.showFilterFields = false;
    if (this.showSearchList) {
      this.showSearchList = false;
    } else {
      this.showSearchList = true;
      this.placeholder = this.searchText || this.placeholder;
      // this.searchText = '';
      this.searchResult = {
        options: [{
          'displayText': "Type something to start searching",
          'text': "Type something to start searching",
          'id': '',
          isError: true
        }]
      }
    }
  }

  clearSearchBox() {
    this.searchText = '';
    this.isTextEntered = false;
    this.showSearchList = false;
    this.isCohertFilterApplied = false;
    if (this.params['user_id'] || this.defaultSelectedField.field_id.startsWith('tag_')) {
      delete this.params['user_id'];
      this.params = {};
      this.loadDataByType(this.default_selected_type);
    }
  }

  searchListSelectedvalue(item) {

    // console.log("searchListSelectedvalue ",item)  
    if (!item.isError) {
      // console.log("searchListSelectedvalue  if",item.isError) 
      this.searchText = item.displayText || item.text;
      this.params['user_id'] = item['id'];
      this.loadDataByType(this.default_selected_type);
      this.showSearchList = false;
    }
  }

  toggleFilterFieldList() {
    this.showSearchList = false;
    if (this.showFilterFields) {
      this.showFilterFields = false;
    } else {
      this.showFilterFields = true;
    }
  }

  processSerchResult(fieldId: string, data: any) {
    if (data && data.code == 0 && data['data'] && data['data'].length > 0) {
      return {
        options: _.map(data.data, (item) => {
          const phoneNumber = item['phone_number']
            ? item['phone_number']
            : '<span class="phone-unavailable">Mobile number is not available</span>';

          return {
            displayText: item[fieldId],
            text: `${item['name'] || ''}<br>${phoneNumber}<br>${item['email_address'] || ''}`,
            id: item.user_id,
            isError: false
          };
        })
      };
    } else {
      return {
        options: [{
          displayText: "No result found",
          text: "No result found",
          id: '',
          isError: true
        }]
      };
    }
  }

  paginateOutbox(pagingType: string) {
    if (this.loading) return;

    this.clearOnDemandRowHighlight();
    this.loading = true;

    const prevPage = this.pagingDetails.pageNumber;

    if (pagingType === 'next') {
      this.pagingDetails.pageNumber++;
    } else if (pagingType === 'previous' && this.pagingDetails.pageNumber > 1) {
      this.pagingDetails.pageNumber--;
    }
    this.params = this.getHierarchyParams(this.params);
    this._verbatim.getListForSentTab({
      ...this.params,
      page_number: this.pagingDetails.pageNumber,
      limit: this.pagingDetails.pageSize,
      is_archived: this.default_selected_type === 'CFRA'
    }).pipe(
      takeUntilDestroyed(this.destroyRef),
      finalize(() => {
        this.loading = false;
        this.cdr.detectChanges();
      })
    ).subscribe({
      next: (outboxDetail) => {
        const data = outboxDetail?.data || {};
        const hasData = data?.requests?.length > 0;
        if (!hasData) {
          // Restore previous page and disable next button
          this.pagingDetails.pageNumber = prevPage;
          this.pagingButtons.isNext = false;
          return;
        }

        // Render new data
        this.prepareDetails(data, this.default_selected_type.toLowerCase());
      },
      error: (err) => {
        console.error("Pagination API error", err);
        this.pagingDetails.pageNumber = prevPage;
        this.loading = false;
      }
    });
  }

  updatePagingDetails(numberOfRecords: any, pageNumber: number) {
    const pageSize = 10;
    const totalFetched = numberOfRecords;
    // Special case: if pageNumber is 1 and only 1 record, show 1 for all
    if (pageNumber === 1 && totalFetched === 1) {
      this.pagingDetails = {
        start: 1,
        end: 1,
        pageSize: pageSize,
        pageNumber: 1,
        total: 1,
        totalpages: 1
      };
      this.pagingButtons.isNext = false;
      this.pagingButtons.isPrevious = false;
      return;
    }
    // start and end dynamically
    const start = totalFetched > 0 ? ((pageNumber - 1) * pageSize) + 1 : 0;
    const end = start + totalFetched - 1;
    // Update paging details
    this.pagingDetails = {
      start: start,
      end: end,
      pageSize: pageSize,
      pageNumber: pageNumber,
      total: start + totalFetched - 1,
      totalpages: totalFetched === pageSize ? pageNumber + 1 : pageNumber
    };
    this.pagingButtons.isNext = totalFetched === pageSize;
    this.pagingButtons.isPrevious = pageNumber > 1;
    // If no data is fetched, disable all buttons
    if (totalFetched === 0) {
      this.pagingButtons.isNext = false;
      this.pagingButtons.isPrevious = false;
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}


